import React from 'react';
import Layout from '@/components/layout/Layout';
import { useLanguage } from '@/context/language-context';

const Privacy = () => {
  const { t } = useLanguage();
  const currentDate = new Date();
  const formattedDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
  
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">{t('privacy.title')}</h1>
          <p className="text-lg text-muted-foreground mb-6">{t('privacy.subtitle')}</p>
          <p className="text-sm text-muted-foreground mb-8">{t('privacy.last_updated')} {formattedDate}</p>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4">{t('privacy.introduction.title')}</h2>
              <p className="text-muted-foreground">{t('privacy.introduction.content')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">1. Information We Collect</h2>
              <p className="text-muted-foreground">
                We collect information that you provide directly to us, including personal data such as your name, 
                email address, and other contact information. We also collect information about your usage of our 
                platform and may collect information from third parties.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">2. How We Use Your Information</h2>
              <p className="text-muted-foreground">
                We use the information we collect to provide, maintain, and improve our services, to process 
                transactions, to communicate with you about our services, and to comply with legal obligations.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">3. Information Sharing</h2>
              <p className="text-muted-foreground">
                We do not sell or rent your personal information to third parties. We may share your information 
                with third-party service providers who perform services on our behalf, when required by law, or 
                in connection with a business transaction.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">4. Your Choices</h2>
              <p className="text-muted-foreground">
                You may update, correct, or delete your account information at any time by logging into your 
                account. You may also opt-out of receiving promotional communications from us by following the 
                instructions in those communications.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;
